export default __webpack_public_path__ + "static/pig07-a4e5aab1ee763052a991dbe602ad273e.png";